import React, { useEffect, useMemo, useState, useContext, createRef } from 'react';
import {  Row, Layout, Menu } from 'antd';
import { useAuthState } from '../../hooks/auth/useAuthState';
import { useTranslations } from '../../hooks/translations/useTranslations';
import { HeaderLogo } from 'app/components/common';
import { Link } from '../common';
import { Translate, authService } from '../../services';
import { QuestionCircleOutlined, SearchOutlined } from '@ant-design/icons';
const { Header } = Layout;
import { Routes } from '../../navigation';
import { ACTIVE_THEME_NAME, IS_SEIKO_THEME, ThemeContext } from '../../branding';
import classNames from 'classnames';
import { useCategoryListQuery } from '../../gql/hooks';
import './styles.less';
import { useMediaQuery } from 'react-responsive';
import { NotificationDropdown } from './NotificationDropdown';
import { FeatureFlag } from '../../featureFlags';
import { flags } from '../../featureFlags/flags';
import { HeaderDropdown } from './HeaderDropdown';
import { CategoryDropdown } from './CategoryDropdown';
import { COMPONENT_LIST_TYPES, useComponentListsQuery } from '../../gql/hooks/queries/useComponentListQuery';

export const AppHeader = () => {
    const { locale, getString } = useTranslations();
    const theme = useContext( ThemeContext );
    const [ dropdownBrand, setDropdownBrand ] = useState( ACTIVE_THEME_NAME );
    const [ loggingOut, setLoggingOut ] = useState( false );
    const { access_token } = useAuthState();

    const { data: componentData } = useComponentListsQuery( COMPONENT_LIST_TYPES.HOMEPAGE, { useMinSearch: true } );

    const [ userDropdownRef, notiDropdownRef, catDropdownRef ] = [ createRef(), createRef(), createRef() ];
    
    const { data: categoryData, loading: categoriesLoading } = useCategoryListQuery();

    const journeyDisabled = useMemo( () => {
        if ( !componentData?.all?.length > 0 ) {
            return true;
        }
        return false;
    }, [ componentData ] );

    const handleOpenPPTX = ( e ) => {
        e.preventDefault();

        const userTags = authService.getTags() || [];

        if ( userTags.includes( 'customer' ) ) {
            if ( locale == 'de-DE' ) {
                window.open( '/documents/HLC_CustomerLearningGuide_deDE_BIW.pdf', '_blank' );
            } else {
                window.open( '/documents/HLC_CustomerLearningGuide_BIW.pdf', '_blank' );
            }
        } else 
            if ( userTags.includes( 'employee' ) ) {
                window.open( '/documents/HLC_EmployeLearningGuide_BIW.pdf', '_blank' );
            } 
    };

    const isSmallLogo = useMediaQuery( { query: '(max-width: 1200px)' } );
    
    const isAuthenticated = useMemo( () => !!access_token, [ access_token ] );

    useEffect( () => {
        window.changeBrand = ( brand ) => {
            window.changeAppBrand( brand );
            setDropdownBrand( brand );
        };
    }, [] );

    function closeOthers( ref ) {
        [ userDropdownRef, notiDropdownRef, catDropdownRef ].forEach( r => {
            if ( r != ref && !!r ) {
                r.current?.close();
            }
        } );
    }

    return (
        <Header className="app-header">
            <Row className="header-row"> 


                <HeaderLogo theme={ theme } small={ isSmallLogo }/> 

                { isAuthenticated &&
                        <Menu className="header-menu text-menu navigation">


                            { /* My Progress */ }
                            { !IS_SEIKO_THEME &&

                                <>
                                    { !journeyDisabled && 

                                        <>
                                            { /* My Journey */ }
                                            <Menu.Item className={ classNames( 'nav-item', 'underline', 'clickable', '_title', 'noselect' ) } key="my-journey" >
                                                <Link push to={ Routes.Home.buildPath() }>
                                                    <Translate.Text value="header.nav.myJourney" />
                                                </Link>
                                            </Menu.Item> 
                                        </>
                                    }
                                    

                                    <Menu.Item className={ classNames( 'nav-item', 'underline', 'clickable', '_title', 'noselect' ) } key="my-progress" >
                                        <Link push to={ Routes.MyProgress.buildPath() }>
                                            <Translate.Text value="header.nav.myProgress" />
                                        </Link>
                                    </Menu.Item>
                                </>
                            }
                            
                            { /* My Learning */ }
                            <Menu.Item className={ classNames( 'nav-item', 'underline', 'clickable', '_title', 'noselect' ) } key="my-learning" >
                                <Link push to={ Routes.Learning.buildPath() }>
                                    <Translate.Text value="header.nav.myLearning" />
                                </Link>
                            </Menu.Item> 

                            { /* Categories */ }
                            <Menu.Item className={ classNames( 'nav-item', 'underline', 'clickable', '_title', 'noselect' ) } key="categories">
                                <CategoryDropdown 
                                    brand={ dropdownBrand } 
                                    onOpenCb={ () => closeOthers( catDropdownRef ) }
                                    ref={ catDropdownRef } 
                                    data={ categoryData } />
                            </Menu.Item>

                            { /* Search */ }
                            <Menu.Item className={ classNames( 'nav-item', 'underline', 'clickable', 'search', '_title', 'noselect' ) } key="search" >
                                <Link push to={ Routes.Search.buildPath() }>
                                    <SearchOutlined />
                                </Link>
                            </Menu.Item>
                        </Menu>
                    }   

                    <Menu className="header-menu right-menu">


                        <FeatureFlag name={ flags.NOTIFICATIONS }>

                            { /*  noti menu */ }
                            <Menu.Item key='notifications-button' className={ classNames( 'nav-item', 'notifications-button', 'clickable', 'noselect' ) }>
                                <NotificationDropdown
                                    brand={ dropdownBrand }
                                    onOpenCb={ () => closeOthers( notiDropdownRef ) }
                                    ref={ notiDropdownRef }
                                    loggingOut={ loggingOut } />
                            </Menu.Item>

                        </FeatureFlag>
                        
                        
                        { /* Question icon */ }
                        { theme !== 'seiko' && isAuthenticated &&
                            <Menu.Item 
                                className={ classNames( 'nav-item', 'icon', 'clickable', 'noselect' ) } 
                                key="help"
                                onClick={ handleOpenPPTX }
                            >
                                <a onClick={ handleOpenPPTX }>
                                    <QuestionCircleOutlined aria-label={ getString( 'icons.help' ) } />
                                </a>
                            </Menu.Item>
                        }
                        
                        { /* Profile Menu */ }
                        <Menu.Item key='profile' className={ classNames( 'nav-item', 'profile', 'clickable', 'user-menu', 'noselect' ) }>

                            <HeaderDropdown 
                                brand={ dropdownBrand } 
                                ref={ userDropdownRef } 
                                onOpenCb={ () => closeOthers( userDropdownRef ) }
                                categoryData={ categoryData } 
                                categoriesLoading={ categoriesLoading } 
                                setLoggingOutCb={ setLoggingOut } />
                        </Menu.Item>
                    </Menu>
            </Row>
        </Header>
    );
};

